import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DistributionStatusCountResponse } from '../models/distribution.model';

export interface EditDistributionEvent {
  distributionId: number;
  readOnly: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class DistributionUiService {
  private editDistributionSubject = new Subject<EditDistributionEvent>();
  private refreshDataSubject = new Subject<void>();

  editDistribution$ = this.editDistributionSubject.asObservable();
  refreshData$ = this.refreshDataSubject.asObservable();
dataChange = new Subject<DistributionStatusCountResponse>();
  emitEditDistribution(distributionId: number, readOnly: boolean = false): void {
    this.editDistributionSubject.next({ distributionId, readOnly });
  }

  emitRefreshData(): void {
    this.refreshDataSubject.next();
  }
}
